export default "__VITE_ASSET__e1f879ef__"